import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {Utils} from '../common/utils';


// Components
import PortfolioInfo from '../elements/PortfolioInfo';
import {Projects} from '../common/vars';

// Elements
import FooterLogo from '../elements/FooterLogo';

import {showProject, hideProject} from '../reducers/PortfolioReducer';

import '../../styles/pages/portfolioProject.css';

class PortfolioProjectPage extends Component {

  project;
  image;
  content;

  componentWillMount() {
    this.props.dispatch(showProject());
  }

  render() {
    this.project = Projects.find((_project) => {
      return _project.slug === this.props.match.params.project;
    });

    this.background = Utils.procesSvg(this.project.images.background);

    return (
      <article className="page portfolio-project-page">
        <div className="portfolio-project-page__content">
          {/* eslint-disable react/no-danger-with-children */}
          <div className="portfolio-project-page__background"
               dangerouslySetInnerHTML={{__html: this.background}}>
          </div>
          {/* eslint-enable react/no-danger-with-children */}
          <div className="portfolio-project-page__content-info" ref={(elem) => {
            this.content = elem
          }}>
            <div className="portfolio-project-page__close" onClick={(e) => this.close(e)}>
            </div>
            <div className="portfolio-project-page__left">
              <img src={this.project.images.main} className="portfolio-project-page__main-image"
                   alt={this.project.name} ref={(elem) => {
                this.image = elem
              }}/>
            </div>
            <div className="portfolio-project-page__right">
              <PortfolioInfo project={this.project}/>
            </div>
          </div>
        </div>
        <FooterLogo darkTheme="true"/>
      </article>
    );
  }

  close(e) {
    this.props.dispatch(hideProject());
    setTimeout(() => {
      this.props.history.push('/portfolio');
    }, 400);
  }

  componentDidMount() {

    this.image.onload = function () {
      this.classList.add('portfolio-project-page__main-image--visible');
    }
    /*
     setTimeout(() => {
     this.content.classList.add('portfolio-project-page__content-info--visible');
     }, 100);
     */
  }

  routerWillLeave() {
    this.props.dispatch(showProject());
  }
}

const mapStateToProps = state => {
  return {
    portfolio: state.portfolio,
  }
};

export default withRouter(connect(mapStateToProps)(PortfolioProjectPage));


// WEBPACK FOOTER //
// ./src/js/pages/PortfolioProjectPage.js